import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface BusinessFileState {
  subscribers: any
  shareholding: any
  partners: any
  directors: any
  secretary: any
  shares_classification: any
  filing_compliance: any
  shares_allotments: any
  filing_history: any
  send_document: any
  send_document_error: any
  success: any
  error: any
  address: any
}

export const useBusinessFileStore = defineStore('businessFile', {
  state: (): BusinessFileState => ({
    subscribers: null,
    shareholding: null,
    partners: null,
    directors: null,
    secretary: null,
    shares_classification: null,
    filing_compliance: null,
    shares_allotments: null,
    filing_history: null,
    send_document: null,
    send_document_error: null,
    success: null,
    error: null,
    address: null,
  }),

  getters: {
    getFilingCompliance: (state) => state.filing_compliance,
    getCompanySubscribers: (state) => state.subscribers,
    getCompanyShareholding: (state) => state.shareholding,
    getBusinessPartners: (state) => state.partners,
    getCompanyDirectors: (state) => state.directors,
    getCompanySecretary: (state) => state.secretary,
    getCompanyAddress: (state) => state.address,
    getCompanyShareClassification: (state) => state.shares_classification,
    getCompanyFilingHistory: (state) => state.filing_history,
    getSendDocumentSuccess: (state) => state.send_document,
    getSendDocumentError: (state) => state.send_document_error,
    getBusinessDetailError: (state) => state.error,
  },

  actions: {
    async fetchCompanySubscribers(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-subscribers/' + brn)
        this.subscribers = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanyDirectors(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-directors/' + brn)
        this.directors = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanySecretary(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-secretary/' + brn)
        this.secretary = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanyShareClassification(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-share-classification/' + brn)
        this.shares_classification = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanyShareholding(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-shareholdings/' + brn)
        this.shareholding = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchBusinessNamePartners(brn: string) {
      try {
        const response = await api().get('/business-registration/details/partners?brn=' + brn)
        this.partners = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanyAddress(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-address/' + brn)
        this.address = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchCompanyFilingHistory(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/filing-history/' + brn)
        this.filing_history = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchFilingCompliance(brn: string) {
      try {
        const response = await api().get('/incorporation/companies/continuous-filing/get-compliance/' + brn)
        this.filing_compliance = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async sendCompanyDocumentToClient(data: any) {
      try {
        const response = await api().post('/incorporation/companies/continuous-filing/resend-client-document', data)
        this.send_document = response.data
      } catch (error: any) {
        this.send_document_error = error.response?.data
      }
    },

    async sendBusinessNameDocumentToClient(data: any) {
      try {
        const response = await api().post('/business-registration/resend-document-copy', data)
        this.send_document = response.data
      } catch (error: any) {
        this.send_document_error = error.response?.data
      }
    },

    async sendBusinessNameCertificateToClient(data: any) {
      try {
        const response = await api().post('/business-registration/resend-certificate', data)
        this.send_document = response.data
      } catch (error: any) {
        this.send_document_error = error.response?.data
      }
    },
  },
})
